import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { Checkbox, FlatButton, RaisedButton } from "material-ui";
import Label from "./label.jsx";
import Select from "react-select";
import BaseOverlay from "./overlays/base.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../../actions/EventBucketActions";
import EventBucketStore from "../../stores/EventBucketStore";

class CloneFilmWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBucket: null,
      selectAll: false,
      cloneList: [],
      isCloning: false
    };

    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets
    };
  }

  handleSelectAll() {
    let currentList = [];
    let films = values(
      pick(this.props.films, e => {
        return (
          e.event_bucket === this.state.selectedBucket.value &&
          e.type !== "livestream" &&
          e.name &&
          e.name !== ""
        );
      })
    );

    films.sort(function (a, b) {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });

    if (this.state.selectAll) {
      films.map(f => {
        currentList.push({ value: f.id, label: f.name });
      });
    }

    this.setState({ cloneList: currentList });
  }

  getStyles() {
    return {
      cloneFilmWidget: {
        backgroundColor: "f2f2f2",
        border: "1px solid black",
        padding: 20,
        marginTop: 25,
        height: "100%"
      },
      fieldLabel: {
        color: "#737373",
        fontWeight: "bold",
        marginBottom: 2
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.state.selectedBucket
        ? this.state.selectedBucket.value
        : null,
      bucketOptions = this.props.getEventBuckets().map(item => {
        return { value: item.id, label: item.name };
      });

    //remove current event bucket from options list
    bucketOptions = bucketOptions.reduce((bucketList, bucket) => {
      if (bucket.value !== this.props.currentBucket) {
        bucketList.push(bucket);
      }
      return bucketList;
    }, []);

    let films = values(
      pick(this.props.films, e => {
        return (
          e.event_bucket === bucket &&
          e.type !== "livestream" &&
          e.name &&
          e.name !== ""
        );
      })
    );

    let selectOptions = films.map(item => {
      return { value: item.id, label: item.name };
    });

    selectOptions.sort(function (a, b) {
      const nameA = a.label.toUpperCase();
      const nameB = b.label.toUpperCase();
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });

    return (
      <BaseOverlay
        title="Clone films from event bucket"
        hideTitleAndFooterBorders={true}
        useMuiDefaultStyle={true}
        openImmediately={true}
        actions={[
          <FlatButton label={"Cancel"} onClick={this.props.onClose} />,
          <FlatButton
            onClick={e => {
              const cloneListIds = this.state.cloneList.map(item => {
                return item.value;
              });
              this.setState({ isCloning: true });
              this.props.onCloneFilms(cloneListIds);
            }}
            label={this.state.isCloning ? "Cloning films..." : "Clone films"}
            disabled={
              this.state.isCloning || this.state.selectedBucket === null
            }
            primary={true}
          />
        ]}
        modal={true}
        open={true}
        onRequestClose={this.props.onClose}
      >
        <Label>Event bucket</Label>
        <div style={{ maxWidth: "400px" }}>
          <Select
            clearable={false}
            autosize={false}
            multi={false}
            placeholder="No event bucket selected"
            value={
              this.state.selectedBucket ? this.state.selectedBucket.value : null
            }
            options={bucketOptions}
            onChange={bucket => {
              this.setState({ selectedBucket: bucket, cloneList: [] });
            }}
          />
        </div>
        {this.state.selectedBucket ? (
          <div style={{ clear: "both", paddingTop: 10 }}>
            <Label>Choose films to clone</Label>
            <Select
              ref={r => {
                this.select = r;
              }}
              multi
              closeOnSelect={false}
              options={selectOptions}
              value={this.state.cloneList}
              onChange={value => {
                this.setState({ cloneList: value });

                // Keep menu open
                setTimeout(() => {
                  if (this.select) {
                    this.select.setState({ isOpen: true });
                  }
                }, 20);
              }}
            ></Select>
            <Checkbox
              label="Select all films from this event bucket"
              value={this.state.selectAll}
              onCheck={e => {
                this.setState(
                  { selectAll: e.target.checked },
                  this.handleSelectAll
                );
              }}
              style={{
                width: "300px",
                paddingTop: 10,
                fontSize: "12px"
              }}
            />
          </div>
        ) : null}
      </BaseOverlay>
    );
  }
}

export default connectToStores(CloneFilmWidget);



// WEBPACK FOOTER //
// ./src/app/components/partials/clone-film-widget.jsx